export default "__VITE_ASSET__BWbkz3Fd__"